<div class="p-container" (click)="onClick()" (contextmenu)="onView($event)">
    <div class="p-card" [ngStyle]="{color:color}">
        {{text}}
    </div>
</div>